var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "md-layout" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "loader" }, [_vm._m(0)])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "md-layout-item" },
        [
          _c(
            "md-card",
            [
              _c(
                "md-button",
                {
                  staticClass:
                    "md-simple md-just-icon md-round modal-default-button",
                  staticStyle: {
                    position: "absolute",
                    top: "3px",
                    left: "10px",
                    "font-size": "30px !important",
                  },
                  on: { click: _vm.openJobsHelp },
                },
                [_c("md-icon", [_vm._v("help")])],
                1
              ),
              _c("h1", { staticClass: "center-title" }, [
                _vm._v("Job Invitations"),
              ]),
              _c("div", { staticClass: "tabs-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "tab",
                    class: { active: _vm.activeTab === "pending" },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "pending"
                      },
                    },
                  },
                  [
                    _vm._v(" Pending Invitations "),
                    _vm.pendingCount
                      ? _c("span", [
                          _vm._v("(" + _vm._s(_vm.pendingCount) + ")"),
                        ])
                      : _vm._e(),
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "tab",
                    class: { active: _vm.activeTab === "previous" },
                    on: {
                      click: function ($event) {
                        _vm.activeTab = "previous"
                      },
                    },
                  },
                  [
                    _vm._v(" Previous Responses "),
                    _vm.previousCount
                      ? _c("span", [
                          _vm._v("(" + _vm._s(_vm.previousCount) + ")"),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]),
              _c(
                "md-card-content",
                [
                  _c("JobInvitationTables", {
                    attrs: {
                      "active-tab": _vm.activeTab,
                      "queried-data": _vm.queriedData,
                      pagination: _vm.pagination,
                      "current-sort": _vm.currentSort,
                      "current-sort-order": _vm.currentSortOrder,
                      "custom-sort": _vm.customSort,
                      "search-query": _vm.searchQuery,
                    },
                    on: {
                      "update:currentSort": function ($event) {
                        _vm.currentSort = $event
                      },
                      "update:current-sort": function ($event) {
                        _vm.currentSort = $event
                      },
                      "update:currentSortOrder": function ($event) {
                        _vm.currentSortOrder = $event
                      },
                      "update:current-sort-order": function ($event) {
                        _vm.currentSortOrder = $event
                      },
                      "update:searchQuery": function ($event) {
                        _vm.searchQuery = $event
                      },
                      "update:search-query": function ($event) {
                        _vm.searchQuery = $event
                      },
                      accept: _vm.acceptInvite,
                      reject: _vm.openRejectionModal,
                      "open-accept-modal": _vm.openAcceptModal,
                    },
                  }),
                  _vm.activeTab === "previous" && _vm.queriedData.length === 0
                    ? _c(
                        "div",
                        { staticClass: "text-center p-4 text-gray-600" },
                        [_c("p", [_vm._v("No previous responses found.")])]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "md-card-actions",
                { attrs: { "md-alignment": "space-between" } },
                [
                  _c("div", [
                    _c("p", { staticClass: "card-category" }, [
                      _vm._v(
                        "Showing " +
                          _vm._s(_vm.from + 1) +
                          " to " +
                          _vm._s(_vm.to) +
                          " of " +
                          _vm._s(_vm.total) +
                          " invitations"
                      ),
                    ]),
                  ]),
                  _c("pagination", {
                    staticClass: "pagination-no-border pagination-success",
                    attrs: {
                      "per-page": _vm.pagination.perPage,
                      total: _vm.total,
                    },
                    model: {
                      value: _vm.pagination.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.pagination, "currentPage", $$v)
                      },
                      expression: "pagination.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showModal
        ? _c(
            "Modal",
            {
              attrs: { size: "default" },
              on: {
                close: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _c("template", { slot: "header" }, [
                _c("h3", { staticClass: "rejection-header" }, [
                  _vm._v("Reason for Rejection"),
                ]),
              ]),
              _c("template", { slot: "body" }, [
                _c("div", { staticClass: "rejection-modal-body" }, [
                  _c("p", { staticClass: "modal-subtext" }, [
                    _vm._v(" You are about to reject the invitation for "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.selectedInvite ? _vm.selectedInvite.job : "")
                      ),
                    ]),
                    _vm._v(" at "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(
                          _vm.selectedInvite ? _vm.selectedInvite.company : ""
                        )
                      ),
                    ]),
                    _vm._v(". Please select a reason for your rejection. "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "radio-group" },
                    [
                      _c("label", { staticClass: "radio-option" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rejectionReason,
                              expression: "rejectionReason",
                            },
                          ],
                          attrs: { type: "radio", value: "Another role" },
                          domProps: {
                            checked: _vm._q(
                              _vm.rejectionReason,
                              "Another role"
                            ),
                          },
                          on: {
                            change: function ($event) {
                              _vm.rejectionReason = "Another role"
                            },
                          },
                        }),
                        _vm._v(" Another role "),
                      ]),
                      _c("label", { staticClass: "radio-option" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rejectionReason,
                              expression: "rejectionReason",
                            },
                          ],
                          attrs: { type: "radio", value: "Not interested" },
                          domProps: {
                            checked: _vm._q(
                              _vm.rejectionReason,
                              "Not interested"
                            ),
                          },
                          on: {
                            change: function ($event) {
                              _vm.rejectionReason = "Not interested"
                            },
                          },
                        }),
                        _vm._v(" Not interested "),
                      ]),
                      _c("label", { staticClass: "radio-option" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.rejectionReason,
                              expression: "rejectionReason",
                            },
                          ],
                          attrs: { type: "radio", value: "Other" },
                          domProps: {
                            checked: _vm._q(_vm.rejectionReason, "Other"),
                          },
                          on: {
                            change: function ($event) {
                              _vm.rejectionReason = "Other"
                            },
                          },
                        }),
                        _vm._v(" Other "),
                      ]),
                      _vm.rejectionReason === "Other"
                        ? _c(
                            "md-field",
                            { staticClass: "mt-2" },
                            [
                              _c("label", [_vm._v("Other reason")]),
                              _c("md-input", {
                                model: {
                                  value: _vm.otherReason,
                                  callback: function ($$v) {
                                    _vm.otherReason = $$v
                                  },
                                  expression: "otherReason",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "modal-footer-actions" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger",
                        on: {
                          click: function ($event) {
                            _vm.showModal = false
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success",
                        attrs: {
                          disabled:
                            !_vm.rejectionReason ||
                            (_vm.rejectionReason === "Other" &&
                              !_vm.otherReason),
                        },
                        on: { click: _vm.confirmRejection },
                      },
                      [_vm._v(" Confirm Rejection ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.showAcceptModal
        ? _c(
            "Modal",
            {
              attrs: { size: "default" },
              on: {
                close: function ($event) {
                  _vm.showAcceptModal = false
                },
              },
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "h3",
                  {
                    staticClass: "rejection-header",
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "8px",
                    },
                  },
                  [
                    _c("md-icon", { staticStyle: { color: "green" } }, [
                      _vm._v("check_circle"),
                    ]),
                    _vm._v(" Confirm Job Acceptance "),
                  ],
                  1
                ),
              ]),
              _c("template", { slot: "body" }, [
                _c("p", [
                  _vm._v(
                    " Are you sure you want to accept the invitation for "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.selectedInvite ? _vm.selectedInvite.job : "")
                    ),
                  ]),
                  _vm._v(" at "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm.selectedInvite ? _vm.selectedInvite.company : ""
                      )
                    ),
                  ]),
                  _vm._v("? "),
                ]),
                _c("p", [
                  _vm._v(
                    " By accepting this invitation, you will be taken to the application form to complete your application for this position. You can review all job details before submitting your final application. "
                  ),
                ]),
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "modal-footer-actions" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-danger",
                        on: {
                          click: function ($event) {
                            _vm.showAcceptModal = false
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success",
                        on: { click: _vm.confirmAcceptInvite },
                      },
                      [_vm._v("Yes, Accept Invitation")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
      _vm.showConfirmationModal
        ? _c(
            "Modal",
            {
              attrs: { size: "default" },
              on: {
                close: function ($event) {
                  _vm.showConfirmationModal = false
                },
              },
            },
            [
              _c("template", { slot: "header" }, [
                _c(
                  "h3",
                  {
                    staticClass: "rejection-header",
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      gap: "8px",
                    },
                  },
                  [
                    _c("md-icon", { staticStyle: { color: "green" } }, [
                      _vm._v("check_circle"),
                    ]),
                    _vm._v(" Confirmation "),
                  ],
                  1
                ),
              ]),
              _c("template", { slot: "body" }, [
                _c("p", [_vm._v(_vm._s(_vm.confirmationMessage))]),
              ]),
              _c("template", { slot: "footer" }, [
                _c(
                  "div",
                  { staticClass: "modal-footer-actions" },
                  [
                    _c(
                      "md-button",
                      {
                        staticClass: "md-success",
                        on: { click: _vm.closeConfirmationModal },
                      },
                      [_vm._v("OK")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-circle" }, [
      _c("div", { staticStyle: { position: "relative" } }, [
        _c("img", { attrs: { src: require("@/assets/img/logo.png") } }),
        _c("div", { staticClass: "loading" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }